<template>
    <a-row>
        <a-col align="center" :lg="2"  @click="$emit('redirect_logout')">
            <LogoutOutlined :style="{ fontSize: '35px' }" />
        </a-col>
        <a-col align="center" :lg="2"  @click="helpdesk">
            <a href="https://wa.me/+584265542945" target="_blank">
                <WhatsAppOutlined :style="{ fontSize: '35px' }" />
            </a>
        </a-col>
        <a-col align="right" :lg="2"  @click="$emit('toggleProfileDrawer', true)">
            <a-badge :count="countMsg">
                <a-avatar
                :size="40"
                v-if="base64Image !== ''"
                :src="base64Image"
                />
                <a-avatar :size="40" v-else>
                    <template #icon>
                        <AntDesignOutlined class="icon" />
                    </template>
                </a-avatar>
                <!-- <a-button @click="openImagePicker">Cambiar foto</a-button>
                <input type="file" ref="imagePicker" @change="uploadImage" style="display: none;" /> -->
            </a-badge>
        </a-col>
        <a-col align="left">
            <template v-if="myscreen == false">
                <PaymentComponent :alert="alert" />
            </template>
            <template v-else>
                <router-link to="/payment_send">
                    <DollarCircleFilled :class="this.showclass" :style="{ fontSize: '35px' }" />
                </router-link>
            </template>
        </a-col>
        <a-col align="left" v-if="myscreen">
            <router-link to="/dashboard">
                <HomeOutlined  :class="icon" :style="{ fontSize: '35px' }" />
            </router-link>
        </a-col>
    </a-row>
</template>
<script>
import { fixImageCliente } from '@/plugins/odoo'
import { AntDesignOutlined, LogoutOutlined, CustomerServiceOutlined, WhatsAppOutlined, DollarCircleFilled, HomeOutlined  } from '@ant-design/icons-vue';
import PaymentComponent from './PaymentHeader.vue';
export default ({
    components: {
        AntDesignOutlined,
        LogoutOutlined,
        CustomerServiceOutlined,
        WhatsAppOutlined,
        DollarCircleFilled,
        HomeOutlined,
        PaymentComponent,
    },
    props: {
        countMsg: {
            type: Number,
            value: 0
        },
        myscreen: {
            type: Boolean,
            value: false
        }
    },
    data() {
        return {
            alert: 
            {
                visible: false,
                type: 'info',
                closable: true,
                saldo: ''
			}, 
            myCliente: this.$route.meta.myCliente,
            base64Image: '',
            // myscreen: 0,
            // breakpoints: {
            //     xs: 480,
            //     sm: 576,
            //     md: 768,
            //     lg: 992,
            //     xl: 1200,
            // },
        }
    },
    emits: ['toggleProfileDrawer', 'redirect_logout' ],

    mounted: function() {
        this.showCliente();
        this.refreshCliente();
        // setInterval( () => {
        //     this.myscreen = this.getColSpan();
        // }, 1000)
    },
    
    computed: {
        showclass() {
            switch(this.alert.type) {
                case "info":
                    if (this.alert.message == 0) {
                        return "dollar_base";
                    } else {
                        return "dollar_info";
                    }
                    break;
                default:
                    return "dollar_warning"
            }
        },
        screenWidth() {
            return window.innerWidth;
        }
    },
    methods: {
        // getColSpan() {
        //     // if (window.innerWidth <= this.breakpoints.md) {
        //     //     return 4; 
        //     // } else {
        //     //     return 8; 
        //     // }
        //     if (this.myscreen === true) {
        //         return 4;
        //     } else {
        //         return 8;
        //     }
        // },
        showCliente() {
            if (this.$route.meta.myCliente) {
                this.myCliente = this.$route.meta.myCliente;
                this.myCliente[0].avatar_128 = fixImageCliente(this.myCliente[0].avatar_128)
                this.myCliente[0].avatar_512 = fixImageCliente(this.myCliente[0].avatar_512)
                this.base64Image = 'data:image/png;base64,'+this.$route.meta.myCliente[0].avatar_128;
                if (this.myCliente[0].credit > 0) {
                    this.myCliente[0].credit_client_dollar = (this.$route.meta.myCliente[0].credit_convert * -1)
                    this.myCliente[0].credit_client_ves = (this.$route.meta.myCliente[0].credit * -1)
                    this.showAlert("error", this.myCliente[0].credit, this.myCliente[0].credit_convert)
                } else {
                    this.myCliente[0].credit_client_dollar = Math.abs(this.$route.meta.myCliente[0].credit_convert)
                    this.myCliente[0].credit_client_ves = Math.abs(this.$route.meta.myCliente[0].credit)
                    this.showAlert("info",  this.myCliente[0].credit_client_ves, this.myCliente[0].credit_client_dollar)
                }
            } else {
                this.base64Image = '';
            }
        },
        refreshCliente() {
            setInterval(() => {
                if (JSON.stringify(this.myCliente) !== JSON.stringify(this.$route.meta.myCliente)) {
                    this.showCliente();   
                }
            }, 5000);
		},
        logoutSend() {
            console.log("salir");
        },
        helpdesk() {
            console.log("Ayuda");
        },
        showAlert(type, message, message2) {
            this.alert.type = type;
            this.alert.visible = true;
            this.alert.message = message;
            this.alert.message2 = message2;
        },
        useBreakpoint() {
            return Grid.useBreakpoint();
        }
    }
});
</script>
<style lang="scss">
@use "sass:selector";
.dollar_info svg path {
    fill: green !important;
}
.dollar_warning svg path {
    fill: red !important;
}
.dollar_base svg path {
    fill: black !important;
}
</style>